import TdlTypeaheadCommon from './tdlTypeaheadCommon';
import { mdiClose, mdiMagnify, mdiArrowLeft } from '@mdi/js';

export default {
  mixins: [TdlTypeaheadCommon],
  props: {
    selectedItems: {
      type: Array,
      required: true,
    },
    disabled: Boolean,
    addNewItem: Boolean,
    itemFactory: Function,
    textAttribute: {
      type: String,
      default: 'text',
    },
    onlyChips: {
      type: Boolean,
      default: false,
    },
    idAttribute: {
      type: String,
      default: 'id',
    },
    softList: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    itemList: {
      type: Array,
      required: true,
    },
    addItemOnKeypress: {
      type: String,
      required: false,
    },
    excludedList: {
      type: Array,
      default: () => [],
    },
    minChars: {
      type: Number,
      default: 0,
    },
    grouped: {
      type: Boolean,
    },
    emptyValuesMessage: {
      type: String,
    },
  },
  computed: {
    inputContainerClasses() {
      return {
        'typeahead-dialog__input-container--open': this.openInputContainer,
      };
    },
  },
  data() {
    return {
      openInputContainer: false,
      searchInputFocused: false,
      mdiClose,
      mdiMagnify,
      mdiArrowLeft,
    };
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.openInputContainer = false;
      }
    },
    searchInputFocused(newVal) {
      this.$emit('focused', { focused: newVal, query: this.query });
    },
    openInputContainer(newVal) {
      if (newVal) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const inputContainerElement = this.$refs.inputDialog;
      document.body.appendChild(inputContainerElement);

      this.$emit('query-changed', this.query);
    });
    // TODO: Refactor this for Vue3
    // this.$on('item-selected', this.reset);
  },
  beforeUnmount() {
    if (this.$refs.inputDialog) {
      document.body.removeChild(this.$refs.inputDialog);
    }

    // TODO: Refactor this for Vue3
    // this.$off('item-selected', this.reset);
  },
  methods: {
    onSearchInputFocus() {
      this.searchInputFocused = true;
    },
    onSearchInputBlur() {
      this.searchInputFocused = false;
    },
    handleFocus() {
      this.openInputContainer = true;
      setTimeout(() => {
        this.reset();
      }, 60);
    },
    reset() {
      this.query = '';
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.$el.focus();
        }
      });
    },
    closeInputContainer() {
      this.openInputContainer = false;
    },
    deleteSelected(item) {
      this.$emit('item-removed', item);
    },
    handleClearSearch() {
      this.reset();
    },
    textInputHandler(event) {
      // Chrome Android doesn't add the key property to keydown events. Use textInput instead.
      if (this.addItemOnKeypress && this.addItemOnKeypress === event.data && this.addNewItem) {
        event.preventDefault();
        this.createItem();
      }
    },
    preventScroll(event) {
      // overrides mixin
      if (this.$refs.$results && !this.$refs.$results.contains(event.target)) {
        event.preventDefault();
      }
    },
    requestFocus() {
      // nothing
    },
  },
};
